import React from 'react'
import classNames from 'classnames'
import { Col, Row } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuilding, faCheckCircle, faClipboardCheck, faIdCard, faStore, faUser } from '@fortawesome/free-solid-svg-icons'
import { PROVIDER_TYPES } from '../../marketplaceConstants'

const HOW_IT_WORKS = [
  { icon: faIdCard, title: 'Regístrate', text: 'Cuéntanos quién eres y adjunta tus documentos.' },
  { icon: faClipboardCheck, title: 'Te verificamos', text: 'El equipo de Homelan revisa tus datos y te da el Sello Homelan.' },
  { icon: faStore, title: 'Publica tus servicios', text: 'Los propietarios te encuentran en el Marketplace y te piden visitas.' }
]

const ACCOUNT_TYPES = [
  {
    value: PROVIDER_TYPES.natural,
    icon: faUser,
    title: 'Persona natural',
    text: 'Trabajas por tu cuenta: plomero, electricista, técnico, carpintero…',
    needs: 'Cédula y certificado de antecedentes o referencias'
  },
  {
    value: PROVIDER_TYPES.company,
    icon: faBuilding,
    title: 'Empresa',
    text: 'Tienes una empresa registrada que presta servicios para el hogar.',
    needs: 'RIF de la empresa y datos del representante legal'
  }
]

const AccountTypeStep = ({ value, onChange, error }) => (
  <>
    <div className="text-center mb-4">
      <h4 className="mb-1">Ofrece tus servicios en Homelan</h4>
      <p className="text-600 mb-0">Llega a los propietarios de los condominios que administran con Homelan.</p>
    </div>

    <Row className="mb-4 text-center">
      {HOW_IT_WORKS.map((item, index) => (
        <Col key={item.title} xs={12} md={4} className="mb-3 mb-md-0">
          <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-soft-primary text-primary mb-2" style={{ width: 44, height: 44 }}>
            <FontAwesomeIcon icon={item.icon} />
          </div>
          <h6 className="mb-1">{`${index + 1}. ${item.title}`}</h6>
          <p className="fs--1 text-600 mb-0">{item.text}</p>
        </Col>
      ))}
    </Row>

    <h5 className="mb-3">¿Cómo te vas a registrar?</h5>
    <Row>
      {ACCOUNT_TYPES.map((type) => {
        const selected = value === type.value
        return (
          <Col key={type.value} md={6} className="mb-3">
            <button
              type="button"
              onClick={() => onChange(type.value)}
              className={classNames('btn btn-block text-left p-3 h-100 border position-relative', {
                'border-primary bg-soft-primary': selected,
                'bg-white': !selected
              })}
              style={{ borderWidth: 2, whiteSpace: 'normal' }}
              aria-pressed={selected}
            >
              {selected && (
                <FontAwesomeIcon icon={faCheckCircle} className="text-primary position-absolute" style={{ top: 12, right: 12 }} />
              )}
              <FontAwesomeIcon icon={type.icon} size="lg" className="text-primary mb-2" />
              <h6 className="mb-1">{type.title}</h6>
              <p className="fs--1 text-700 mb-2">{type.text}</p>
              <p className="fs--2 text-600 mb-0">Necesitarás: {type.needs}</p>
            </button>
          </Col>
        )
      })}
    </Row>
    {error && <small className="text-danger d-block">{error}</small>}
  </>
)

export default AccountTypeStep
